<template>
	<div class="pay_img">
		<div class="flex flex_between">
			<img :src="imgList[itemDetail.imgUrl1]" alt/>
			<div class="flex flex_between line_box line_box_fully_paid" v-if="isFullyPaid">
				<span class="line_span"></span>
				<i class="fa fa-check center_i" aria-hidden="true"></i>
				<i class="fa fa-long-arrow-right" aria-hidden="true"></i>
			</div>
			<div class="flex flex_between line_box line_box_partially_paid" v-if="isPartiallyPaid">
				<span class="line_span"></span>
				<i class="fa fa-check center_i" aria-hidden="true"></i>
				<i class="fa fa-long-arrow-right" aria-hidden="true"></i>
			</div>
			<div class="flex flex_between line_box line_box_unpaid" v-if="isUnpaid">
				<span class="line_span"></span>
				<i class="fa fa-clock-o center_i" aria-hidden="true"></i>
				<i class="fa fa-long-arrow-right" aria-hidden="true"></i>
			</div>
			<img :src="imgList[itemDetail.imgUrl2]" alt/>
		</div>
	</div>
</template>
<script>
import {paymentProgress} from "@/common/utils/paymentProgress";

export default {
	props: {
		itemDetail: Object,
	},
	data() {
		return {
			paymentProgress: paymentProgress,
			imgList: {
				debtor: require("@/assets/img/seller/debtor_icon.svg"),
				buyer: require("@/assets/img/seller/investor_icon.svg"),
				seller: require("@/assets/img/seller/supplier_icon.svg"),
				seller_walbing: require("@/assets/img/seller/supplier_walbing_icon.svg"),
				walbing: require("@/assets/img/seller/Walbing_icon.svg")
			}
		};
	},
	computed: {
		isFullyPaid() {
			return paymentProgress.statusOptions.isFullyPaid(this.itemDetail.payStatus);
		},
		isPartiallyPaid() {
			return paymentProgress.statusOptions.isPartiallyPaid(this.itemDetail.payStatus);
		},
		isUnpaid() {
			return paymentProgress.statusOptions.isUnpaid(this.itemDetail.payStatus);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base.scss";

.pay_img {
	img {
		width: rem(45);
		height: rem(45);
	}
	.line_box {
		.line_span {
			display: inline-block;
			width: rem(20);
			height: rem(4);
		}
		.center_i {
			margin: 0 rem(15);
		}
		padding: 0 rem(20);
		font-size: rem(20);
	}

	.line_box_unpaid {
		span.line_span {
			background-color: #8C939B;
		}
		i.fa {
			color: #8C939B;
		}
	}

	.line_box_partially_paid {
		span.line_span {
			background-color: #F6DA8F;
		}
		i.fa {
			color: #F6DA8F;
		}
	}

	.line_box_fully_paid {
		span.line_span {
			background-color: #BCE1A3;
		}
		i.fa {
			color: #BCE1A3;
		}
	}
}
</style>